const getValidUrl = (url: string) => {
    try {
        const validUrl = new URL(url);
        if (!['https:', 'http:'].includes(validUrl.protocol)) {
            throw new Error('Invalid url protocol');
        }
        return validUrl.toString();
    } catch (error) {
        return null;
    }
};

export default getValidUrl;
